import { vueComponentMixin } from '@tencent/data-schema/lib/vue-ui/definitions';
import { AUTO_COMPONENT_ID_PREFIX, INJECT_UICORE_DESIGNER } from "../../../../lib/utils/consts";
import { highlightRect } from "../../../../lib/utils/browser/highlightRect";
const __script_base__ = {
  name: 'FormSelector',
  mixins: [vueComponentMixin],
  inject: {
    designer: {
      from: INJECT_UICORE_DESIGNER
    }
  },
  data() {
    return {
      formList: []
    };
  },
  methods: {
    highlightForm(compPath) {
      if (!compPath) return;
      const inst = this.designer.renderer.getRefByPath(compPath);
      const el = inst === null || inst === void 0 ? void 0 : inst.$el;
      if (el) highlightRect(el.getBoundingClientRect());
    },
    reloadFormList() {
      /** @type {{ renderer: UICore.CRenderer }} */
      const {
        renderer
      } = this.designer;
      const pendings = [renderer.ucRootForm];
      const ans = [{
        id: '',
        name: '当前组件所在的表单',
        compPath: ''
      }, {
        id: '<root>',
        name: '整个页面',
        compPath: ''
      }];
      while (pendings.length) {
        var _form$$vnode;
        const form = pendings.pop();
        if (form !== null && form !== void 0 && form.subForms) pendings.push(...form.subForms.values());

        /** @type {Vue.VNodeData} */
        const vnodeData = form === null || form === void 0 || (_form$$vnode = form.$vnode) === null || _form$$vnode === void 0 ? void 0 : _form$$vnode.data;
        if (!vnodeData) continue;
        if (vnodeData['uc:renderer'].ucRendererUUID !== renderer.ucRendererUUID) continue;
        const id = vnodeData.key;
        if (id && !id.startsWith(AUTO_COMPONENT_ID_PREFIX)) {
          ans.push({
            id,
            name: id,
            compPath: vnodeData['uc:path']
          });
        }
      }
      this.formList = ans;
      return ans;
    }
  },
  created() {
    this.reloadFormList();
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c('a-select', {
    staticStyle: {
      "display": "block",
      "flex": "1"
    },
    attrs: {
      "show-search": "",
      "placeholder": "默认校验当前组件所在的表单",
      "filter-option": ""
    },
    on: {
      "focus": _vm.reloadFormList
    },
    model: {
      value: _vm.editValue,
      callback: function ($$v) {
        _vm.editValue = $$v;
      },
      expression: "editValue"
    }
  }, _vm._l(_vm.formList, function (form) {
    return _c('a-select-option', {
      key: form.id,
      attrs: {
        "value": form.id
      },
      on: {
        "mouseenter": function ($event) {
          return _vm.highlightForm(form.compPath);
        }
      }
    }, [_vm._v("\n    " + _vm._s(form.name) + "\n  ")]);
  }), 1);
};
var staticRenderFns = [];
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "builtin/flowAtoms/paramsFormComponents/formSelector.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);